import { render, staticRenderFns } from "./VolunteerUpgradeCard.vue?vue&type=template&id=65cfbfd0&scoped=true&"
import script from "./VolunteerUpgradeCard.vue?vue&type=script&lang=js&"
export * from "./VolunteerUpgradeCard.vue?vue&type=script&lang=js&"
import style0 from "./VolunteerUpgradeCard.vue?vue&type=style&index=0&id=65cfbfd0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65cfbfd0",
  null
  
)

export default component.exports